
import type { SVGProps } from 'react';
const SvgProducts = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M20.5 7.28 12 3 3.5 7.28v9.44L12 21l8.5-4.28zM12 5.18l5.88 2.96L12 11.1 6.12 8.14zM5.5 9.66l5.5 2.77v6.42l-5.5-2.77zm7.5 9.19v-6.42l5.5-2.77v6.42z"
    />
  </svg>
);
export default SvgProducts;
